import $ from "jquery";
import {flashMessage} from "./popups";
function sendEmail(form, formData, {serviceArray = {}, finalPrice = 0, detailsArray = {}} = {}) {
    fetch(form.action, {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            _token: formData.get("_token"),
            type: formData.get("type"),
            name: formData.get("name"),
            surname: formData.get("surname"),
            phone: formData.get("phone"),
            message: formData.get("message"),
            email: formData.get("email"),
            serviceArray: JSON.stringify(serviceArray),
            finalPrice: finalPrice,
            detailsArray: JSON.stringify(detailsArray),
        }),
    })
        .then((response) => {
            if (response.ok) {
                flashMessage($t('site_labels.thank_you') + ' ' + $t('site_labels.your_application_has_been_successfully_sent'));
            }
            $('.question-form__input').each(function () {
                $(this).val('');
            });
            $('.diagnostic__wrapper').addClass('hide-popup').removeClass('show-popup');
            const button = $('.price-button');
            const button1 = $('.send-form');
            const button2 = $('.diagnostic-popup__button');
            button.html($t('site_labels.order'));
            button1.html($t('site_labels.send'));
            button2.html($t('site_labels.send'));
            button.removeAttr('disabled');
            button1.removeAttr('disabled');
            button2.removeAttr('disabled');
        })
        .catch((error) => {
            flashMessage('Вибачте, сталася помилка.')
            console.error(error)
        });
}

export default sendEmail;
